import { RSAA } from 'redux-api-middleware';
import { getGeolocation } from '../../utils/helper/page-behavior-helper';
import { getRequestAdditionalHeader } from './util-actions';

export const PRINCIPAL_SELECT = '/personal-lending/loan/principal/select';
export const PRINCIPAL_SELECT_SUCCESS = '/personal-lending/loan/principal/select/success';
export const PRINCIPAL_SELECT_FAILURE = '/personal-lending/loan/principal/select/failure';

export const SUBMIT_NEW = '/personal-lending/loan/application/new';
export const SUBMIT_NEW_SUCCESS = '/personal-lending/loan/application/new/success';
export const SUBMIT_NEW_FAILURE = '/personal-lending/loan/application/new/failure';

export const SUBMIT_LEAD_COMPLEMENT = '/personal-lending/loan/application/lead-complement';
export const SUBMIT_LEAD_COMPLEMENT_SUCCESS = '/personal-lending/loan/application/lead-complement/success';
export const SUBMIT_LEAD_COMPLEMENT_FAILURE = '/personal-lending/loan/application/lead-complement/failure';

export const SUBMIT_NEW_LEAD = '/personal-lending/loan/application/new-lead';
export const SUBMIT_NEW_LEAD_SUCCESS = '/personal-lending/loan/application/new-lead/success';
export const SUBMIT_NEW_LEAD_FAILURE = '/personal-lending/loan/application/new-lead/failure';

export const SAVE_LEAD = '/personal-lending/loan/application/save-lead';
export const SAVE_LEAD_SUCCESS = '/personal-lending/loan/application/save-lead/success';
export const SAVE_LEAD_FAILURE = '/personal-lending/loan/application/save-lead/failure';

export const SUBMIT_BASIC = '/personal-lending/loan/application/basic';
export const SUBMIT_BASIC_SUCCESS = '/personal-lending/loan/application/basic/success';
export const SUBMIT_BASIC_FAILURE = '/personal-lending/loan/application/basic/failure';

export const SUBMIT_PRE_CONTRACT = '/personal-lending/loan/application/contract/pre';
export const SUBMIT_PRE_CONTRACT_SUCCESS = '/personal-lending/loan/application/contract/pre/success';
export const SUBMIT_PRE_CONTRACT_FAILURE = '/personal-lending/loan/application/contract/pre/failure';

export const SUBMIT_MOBILE_COLLATERAL_CONSENT = '/personal-lending/loan/application/collateral/mobile/consent';
export const SUBMIT_MOBILE_COLLATERAL_CONSENT_SUCCESS =
  '/personal-lending/loan/application/collateral/mobile/consent/success';
export const SUBMIT_MOBILE_COLLATERAL_CONSENT_FAILURE =
  '/personal-lending/loan/application/collateral/mobile/consent/failure';

export const SUBMIT_MOBILE_COLLATERAL_CODE = '/personal-lending/loan/application/collateral/mobile/code';
export const SUBMIT_MOBILE_COLLATERAL_CODE_SUCCESS =
  '/personal-lending/loan/application/collateral/mobile/code/success';
export const SUBMIT_MOBILE_COLLATERAL_CODE_FAILURE =
  '/personal-lending/loan/application/collateral/mobile/code/failure';

export const RE_CONFIRM_CONTRACT = '/persona-lending/loan/application/contract/re-confirm';
export const RE_CONFIRM_CONTRACT_SUCCESS = '/personal-lending/loan/application/contract/re-confirm/success';
export const RE_CONFIRM_CONTRACT_FAILURE = '/personal-lending/loan/application/contract/re-confirm/failure';

export const CANCEL_CONTRACT = '/personal-lending/loan/application/contract/cancel';
export const CANCEL_CONTRACT_SUCCESS = '/personal-lending/loan/application/contract/cancel/success';
export const CANCEL_CONTRACT_FAILURE = '/personal-lending/loan/application/contract/cancel/failure';

export const REQUEST_ORIGINAL_OFFER = '/personal-lending/loan/application/contract/request-original-offer';
export const REQUEST_ORIGINAL_OFFER_SUCCESS =
  '/personal-lending/loan/application/contract/request-original-offer/success';
export const REQUEST_ORIGINAL_OFFER_FAILURE =
  '/personal-lending/loan/application/contract/request-original-offer/failure';

export const SIGN_CONTRACT = '/personal-lending/loan/application/contract';
export const SIGN_CONTRACT_SUCCESS = '/personal-lending/loan/application/contract/success';
export const SIGN_CONTRACT_FAILURE = '/personal-lending/loan/application/contract/failure';

export const SUBMIT_INSTANTOR = '/personal-lending/loan/application/income/instantor';
export const SUBMIT_INSTANTOR_SUCCESS = '/personal-lending/loan/application/income/instantor/success';
export const SUBMIT_INSTANTOR_FAILURE = '/personal-lending/loan/application/income/instantor/failure';

export const SUBMIT_CREDIGO = '/personal-lending/loan/application/income/credigo';
export const SUBMIT_CREDIGO_SUCCESS = '/personal-lending/loan/application/income/credigo/success';
export const SUBMIT_CREDIGO_FAILURE = '/personal-lending/loan/application/income/credigo/failure';

export const SUBMIT_IDENTITY = '/personal-lending/loan/application/identity';
export const SUBMIT_IDENTITY_SUCCESS = '/personal-lending/application/identity/success';
export const SUBMIT_IDENTITY_FAILURE = '/personal-lending/applicatoin/identity/failure';

export const SUBMIT_PSYCHROMETRIC = '/personal-lending/loan/application/income/submit-psychrometric';
export const SUBMIT_PSYCHROMETRIC_SUCCESS = '/personal-lending/loan/application/income/submit-psychrometric/success';
export const SUBMIT_PSYCHROMETRIC_FAILURE = '/personal-lending/loan/application/income/submit-psychrometric/failure';

export const SUBMIT_BANK_STATEMENT = '/personal-lending/loan/application/income/document';
export const SUBMIT_BANK_STATEMENT_SUCCESS = '/personal-lending/loan/application/income/document/success';
export const SUBMIT_BANK_STATEMENT_FAILURE = '/personal-lending/loan/application/income/document/failure';

export const SUBMIT_POST_CONTRACT = '/personal-lending/loan/application/contract/post';
export const SUBMIT_POST_CONTRACT_SUCCESS = '/personal-lending/loan/application/contract/post/success';
export const SUBMIT_POST_CONTRACT_FAILURE = '/personal-lending/loan/application/contract/post/failure';

export const REQUEST_VALIDATION_CODE = '/personal-lending/loan/application/verification-code/request';
export const REQUEST_VALIDATION_CODE_SUCCESS = '/personal-lending/loan/application/verification-code/request/success';
export const REQUEST_VALIDATION_CODE_FAILURE = '/personal-lending/loan/application/verification-code/request/failure';

export const UPDATE_BANK_INFORMATION = '/personal-lending/loan/application/update-bank-information';
export const UPDATE_BANK_INFORMATION_SUCCESS = '/personal-lending/loan/application/update-bank-information/success';
export const UPDATE_BANK_INFORMATION_FAILURE = '/personal-lending/loan/application/update-bank-information/failure';

export const SUBMIT_PROMOTIONAL_CODE = 'personal-lending/loan/application/contract/promotional-code';
export const SUBMIT_PROMOTIONAL_CODE_SUCCESS = 'personal-lending/loan/application/contract/promotional-code/success';
export const SUBMIT_PROMOTIONAL_CODE_FAILURE = 'personal-lending/loan/application/contract/promotional-code/failure';

export const FIND_CURRENT_LOAN_OFFERS = '/customer/loan/current/offers';
export const FIND_CURRENT_LOAN_OFFERS_SUCCESS = '/customer/loan/current/offers/success';
export const FIND_CURRENT_LOAN_OFFERS_FAILURE = '/customer/loan/current/offers/failure';

export const FIND_CURRENT_LOAN_MULTIOFFER = '/customer/loan/current/multioffer';
export const FIND_CURRENT_LOAN_MULTIOFFER_SUCCESS = '/customer/loan/current/multioffer/success';
export const FIND_CURRENT_LOAN_MULTIOFFER_FAILURE = '/customer/loan/current/multioffer/failure';

export const SELECT_FROM_MULTIOFFER = '/customer/loan/current/multioffer/select';
export const SELECT_FROM_MULTIOFFER_SUCCESS = '/customer/loan/current/multioffer/select/success';
export const SELECT_FROM_MULTIOFFER_FAILURE = '/customer/loan/current/multioffer/select/failure';

export const UNSELECT_FROM_MULTIOFFER = '/customer/loan/current/multioffer/unselect';
export const UNSELECT_FROM_MULTIOFFER_SUCCESS = '/customer/loan/current/multioffer/unselect/success';
export const UNSELECT_FROM_MULTIOFFER_FAILURE = '/customer/loan/current/multioffer/unselect/failure';

export const SUBMIT_CURRENT_LOAN_OFFER = '/customer/loan/current/offer/submit';
export const SUBMIT_CURRENT_LOAN_OFFER_SUCCESS = '/customer/loan/current/offer/submit/success';
export const SUBMIT_CURRENT_LOAN_OFFER_FAILURE = '/customer/loan/current/offer/submit/failure';

export const GATHER_ADDRESS = '/personal-lending/loan/application/gather-address';
export const GATHER_ADDRESS_SUCCESS = '/personal-lending/loan/application/gather-address/success';
export const GATHER_ADDRESS_FAILURE = '/personal-lending/loan/application/gather-address/failure';

export const REQUEST_IASSESSEMENTS = '/personal-lending/loan/application/approved/iassessements';
export const REQUEST_IASSESSEMENTS_SUCCESS = '/personal-lending/loan/application/approved/iassessements/success';
export const REQUEST_IASSESSEMENTS_FAILURE = '/personal-lending/loan/application/approved/iassessements/failure';

export const APPLY_FOR_INSURANCE = '/personal-lending/loan/application/insurance/apply/post';
export const APPLY_FOR_INSURANCE_SUCCESS = '/personal-lending/loan/application/insurance/apply/post/success';
export const APPLY_FOR_INSURANCE_FAILURE = '/personal-lending/loan/application/insurance/apply/post/failure';

export const CANCEL_INSURANCE = '/personal-lending/loan/application/insurance/cancel/post';
export const CANCEL_INSURANCE_SUCCESS = '/personal-lending/loan/application/insurance/cancel/post/success';
export const CANCEL_INSURANCE_FAILURE = '/personal-lending/loan/application/insurance/cancel/post/failure';

export const GET_KBA_QUESTIONS = '/personal-lending/loan/kba/questions';
export const GET_KBA_QUESTIONS_SUCCESS = '/personal-lending/loan/loan/kba/questions/sucess';
export const GET_KBA_QUESTIONS_FAILURE = '/personal-lending/loan/kba/questions/failure';

export const SAVE_KBA_QUESTIONS = '/personal-lending/loan/kba/save/responses';
export const SAVE_KBA_QUESTIONS_SUCCESS = '/personal-lending/loan/kba/save/responses/success';
export const SAVE_KBA_QUESTIONS_FAILURE = '/personal-lending/loan/kba/save/responses/failure';

export const FIND_MULTIPLE_LOAN_OFFERS = '/customer/loan/current/offers/multiple';
export const FIND_MULTIPLE_LOAN_OFFERS_SUCCESS = '/customer/loan/current/offers/multiple/success';
export const FIND_MULTIPLE_LOAN_OFFERS_FAILURE = '/customer/loan/current/offers/multiple/failure';

export const SELECT_LOAN_OFFER = '/customer/loan/current/offer/select';
export const SELECT_LOAN_OFFER_SUCCESS = '/customer/loan/current/offer/select/success';
export const SELECT_LOAN_OFFER_FAILURE = '/customer/loan/current/offer/select/failure';

export const SUBMIT_MOBILE_COMPATIBILITY = '/customer/loan/application/mobile-compatibility';
export const SUBMIT_MOBILE_COMPATIBILITY_SUCCESS = '/customer/loan/application/mobile-compatibility/success';
export const SUBMIT_MOBILE_COMPATIBILITY_FAILURE = '/customer/loan/application/mobile-compatibility/failure';

export const SUBMIT_APP_INSTALLATION_DENIAL = '/customer/loan/application/app-installation-denial';
export const SUBMIT_APP_INSTALLATION_DENIAL_SUCCESS = '/customer/loan/application/app-installation-denial/success';
export const SUBMIT_APP_INSTALLATION_DENIAL_FAILURE = '/customer/loan/application/app-installation-denial/failure';

export const FIND_COUNTER_OFFER = '/customer/loan/application/counter-offer';
export const FIND_COUNTER_OFFER_SUCCESS = '/customer/loan/application/counter-offer/success';
export const FIND_COUNTER_OFFER_FAILURE = '/customer/loan/application/counter-offer/failure';

export const TAG_ANALYTICS_EVENT = '/customer/loan/application/tag-analytics-event';
export const TAG_ANALYTICS_EVENT_SUCCESS = '/customer/loan/application/tag-analytics-event/success';
export const TAG_ANALYTICS_EVENT_FAILURE = '/customer/loan/application/tag-analytics-event/failure';

export const GET_INSTITUTIONS_REQUEST = '/customer/loan/application/institutions';
export const GET_INSTITUTIONS_SUCCESS = "/customer/loan/application/institutions/sucess";
export const GET_INSTITUTIONS_FAILURE = "/customer/loan/application/institutions/failure";

export const CREATE_CONSENT_REQUEST = "/customer/loan/application/create-consent";
export const CREATE_CONSENT_SUCCESS = "/customer/loan/application/create-consent/success";
export const CREATE_CONSENT_FAILURE = "/customer/loan/application/create-consent/failure";

/**
 * Selects the principal for a loan.
 */
export function selectPrincipal(principal, proceed = false, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/principal`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: principal,
      types: [PRINCIPAL_SELECT, { type: PRINCIPAL_SELECT_SUCCESS, meta: { proceed } }, PRINCIPAL_SELECT_FAILURE],
    },
  };
}

/**
 * Submits a new application.
 */
export function submitNew(application, password, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/new`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        password,
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify(application).replace(/"\s+|\s+"/g, '"'),
      types: [SUBMIT_NEW, SUBMIT_NEW_SUCCESS, SUBMIT_NEW_FAILURE],
    },
  };
}

export function submitNewLead(application, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/new`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify(application).replace(/"\s+|\s+"/g, '"'),
      types: [SUBMIT_NEW_LEAD, SUBMIT_NEW_LEAD_SUCCESS, SUBMIT_NEW_LEAD_FAILURE],
    },
  };
}

export function saveLead(payload, device, origin) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/lead/new?origin=${origin}`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify(payload).replace(/"\s+|\s+"/g, '"'),
      types: [SAVE_LEAD, SAVE_LEAD_SUCCESS, SAVE_LEAD_FAILURE],
    },
  };
}

export function submitApplicationLeadComplement(application, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/lead-complement`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify(application).replace(/"\s+|\s+"/g, '"'),
      types: [SUBMIT_LEAD_COMPLEMENT, SUBMIT_LEAD_COMPLEMENT_SUCCESS, SUBMIT_LEAD_COMPLEMENT_FAILURE],
    },
  };
}
/**
 * Submits a basic application.
 */
export function submitBasic(application, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/basic`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify(application).replace(/"\s+|\s+"/g, '"'),
      types: [SUBMIT_BASIC, SUBMIT_BASIC_SUCCESS, SUBMIT_BASIC_FAILURE],
    },
  };
}

/**
 * Submits a mobile collateral consent.
 */
export function submitMobileCollateralConsent(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/collateral/mobile`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [
        SUBMIT_MOBILE_COLLATERAL_CONSENT,
        SUBMIT_MOBILE_COLLATERAL_CONSENT_SUCCESS,
        SUBMIT_MOBILE_COLLATERAL_CONSENT_FAILURE,
      ],
    },
  };
}

/**
 * Submits a pre-contract application.
 */
export function submitPreContract(application, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/contract/pre`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify(application).replace(/"\s+|\s+"/g, '"'),
      types: [SUBMIT_PRE_CONTRACT, SUBMIT_PRE_CONTRACT_SUCCESS, SUBMIT_PRE_CONTRACT_FAILURE],
    },
  };
}

/**
 * Signs an application contract.
 */
export function signContract(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/contract`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [SIGN_CONTRACT, SIGN_CONTRACT_SUCCESS, SIGN_CONTRACT_FAILURE],
    },
  };
}

export function reConfirmContract(device, validationCode) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/contract/re-confirm?code=${validationCode}`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [RE_CONFIRM_CONTRACT, RE_CONFIRM_CONTRACT_SUCCESS, RE_CONFIRM_CONTRACT_FAILURE],
    },
  };
}

export function cancelContract(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: '/api/loan/application/contract/cancel',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [CANCEL_CONTRACT, CANCEL_CONTRACT_SUCCESS, CANCEL_CONTRACT_FAILURE],
    },
  };
}

export function requestOriginalOffer(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: '/api/loan/application/contract/request-original-offer',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [REQUEST_ORIGINAL_OFFER, REQUEST_ORIGINAL_OFFER_SUCCESS, REQUEST_ORIGINAL_OFFER_FAILURE],
    },
  };
}

/**
 * Submits instantor.
 */
export function submitInstantor(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/instantor`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [SUBMIT_INSTANTOR, SUBMIT_INSTANTOR_SUCCESS, SUBMIT_INSTANTOR_FAILURE],
    },
  };
}

/**
 * Submits bank statements.
 */
export function submitBankStatement(files, device) {
  getGeolocation();
  const data = new FormData();
  files.forEach((file) => data.append('documents', file));
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/bank-statement`,
      method: 'PUT',
      headers: {
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: data,
      types: [SUBMIT_BANK_STATEMENT, SUBMIT_BANK_STATEMENT_SUCCESS, SUBMIT_BANK_STATEMENT_FAILURE],
    },
  };
}

/**
 * Submits a post-contract application.
 */
export function submitPostContract(application, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/contract/post`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify(application).replace(/"\s+|\s+"/g, '"'),
      types: [SUBMIT_POST_CONTRACT, SUBMIT_POST_CONTRACT_SUCCESS, SUBMIT_POST_CONTRACT_FAILURE],
    },
  };
}

/**
 * Submits an insurance contract.
 */
export function applyForInsurance(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/insurance-apply`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [APPLY_FOR_INSURANCE, APPLY_FOR_INSURANCE_SUCCESS, APPLY_FOR_INSURANCE_FAILURE],
    },
  };
}

/**
 * Submits an insurance cancel.
 */
export function cancelInsurance(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/insurance-cancel`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [CANCEL_INSURANCE, CANCEL_INSURANCE_SUCCESS, CANCEL_INSURANCE_FAILURE],
    },
  };
}

/*
 * Submit mobile collateral code
 */
export function submitMobileCollateralCode(mobileCollateralCode, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/collateral/mobile/code`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Mobile-Collateral-Code': mobileCollateralCode,
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [
        SUBMIT_MOBILE_COLLATERAL_CODE,
        SUBMIT_MOBILE_COLLATERAL_CODE_SUCCESS,
        SUBMIT_MOBILE_COLLATERAL_CODE_FAILURE,
      ],
    },
  };
}

/**
 * Submits credigo.
 */
export function submitCredigo(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/credigo`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [SUBMIT_CREDIGO, SUBMIT_CREDIGO_SUCCESS, SUBMIT_CREDIGO_FAILURE],
    },
  };
}

/**
 * Submits identity.
 */
export function submitIdentity(image, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: '/api/loan/application/identity',
      method: 'PUT',
      headers: {
        'Content-Type': 'image/jpg',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: image,
      types: [SUBMIT_IDENTITY, SUBMIT_IDENTITY_SUCCESS, SUBMIT_IDENTITY_FAILURE],
    },
  };
}

export function updateBankInformation(bankCode, branchNumber, accountNumber, checkDigit, dueDay, device) {
  return {
    [RSAA]: {
      endpoint: '/api/loan/application/update-bank-information',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        bankCode,
        branchNumber,
        accountNumber,
        checkDigit,
        dueDay,
      }).replace(/"\s+|\s+"/g, '"'),
      types: [UPDATE_BANK_INFORMATION, UPDATE_BANK_INFORMATION_SUCCESS, UPDATE_BANK_INFORMATION_FAILURE],
    },
  };
}
/**
 * Submits credigo.
 */
export function submitPsychrometric(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/submit-psychrometric`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [SUBMIT_PSYCHROMETRIC, SUBMIT_PSYCHROMETRIC_SUCCESS, SUBMIT_PSYCHROMETRIC_FAILURE],
    },
  };
}

export function submitPromotionalCode(promotionalCode, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/promotional-code?promotionalCode=${promotionalCode}`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [SUBMIT_PROMOTIONAL_CODE, SUBMIT_PROMOTIONAL_CODE_SUCCESS, SUBMIT_PROMOTIONAL_CODE_FAILURE],
    },
  };
}

/**
 * Finds current loan available offers/conditions.
 */
export function findCurrentLoanOffers(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/offers`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [FIND_CURRENT_LOAN_OFFERS, FIND_CURRENT_LOAN_OFFERS_SUCCESS, FIND_CURRENT_LOAN_OFFERS_FAILURE],
    },
  };
}

/**
 * Finds current loan multioffer offers/conditions.
 */
export function findCurrentLoanMultiOffers(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/multioffer`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [FIND_CURRENT_LOAN_MULTIOFFER, FIND_CURRENT_LOAN_MULTIOFFER_SUCCESS, FIND_CURRENT_LOAN_MULTIOFFER_FAILURE],
    },
  };
}

/**
 * Select offers/conditions from multioffer.
 */
export function selectFromMultiOffers(offer, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/multioffer/select`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify(offer),
      types: [SELECT_FROM_MULTIOFFER, SELECT_FROM_MULTIOFFER_SUCCESS, SELECT_FROM_MULTIOFFER_FAILURE],
    },
  };
}

/**
 * Undo select offer from multioffer.
 */
export function undoSelectFromMultiOffers(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/multioffer/unselect`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [UNSELECT_FROM_MULTIOFFER, UNSELECT_FROM_MULTIOFFER_SUCCESS, UNSELECT_FROM_MULTIOFFER_FAILURE],
    },
  };
}

export function gatherAddress(zipcode, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/gather-address?zipcode=${zipcode}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [GATHER_ADDRESS, GATHER_ADDRESS_SUCCESS, GATHER_ADDRESS_FAILURE],
    },
  };
}
/*
 * Get IAssessements questionnaire
 */
export function getIassessements(taxId, device) {
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/iassessements?taxId=${taxId}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [REQUEST_IASSESSEMENTS, REQUEST_IASSESSEMENTS_SUCCESS, REQUEST_IASSESSEMENTS_FAILURE],
    },
  };
}

/*
 * Get questions
 */
export function getKbaQuestion(device) {
  return {
    [RSAA]: {
      endpoint: `/api/loan/questions?forceUpdate=true`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },

      types: [GET_KBA_QUESTIONS, GET_KBA_QUESTIONS_SUCCESS, GET_KBA_QUESTIONS_FAILURE],
    },
  };
}

/*
 * Save user responses
 */
export function saveKbaResponses(body, device) {
  return {
    [RSAA]: {
      endpoint: `/api/loan/questions`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify(body),
      types: [SAVE_KBA_QUESTIONS, SAVE_KBA_QUESTIONS_SUCCESS, SAVE_KBA_QUESTIONS_FAILURE],
    },
  };
}

/**
 * Finds current loan available offers/conditions.
 */
export function findMultipleLoanOffers(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/offers/multiple`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [FIND_MULTIPLE_LOAN_OFFERS, FIND_MULTIPLE_LOAN_OFFERS_SUCCESS, FIND_MULTIPLE_LOAN_OFFERS_FAILURE],
    },
  };
}

/**
 * Submit Loan Selected Conditions
 */
export function submitCurrentLoanConditions(condition, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/condition`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify(condition).replace(/"\s+|\s+"/g, '"'),
      types: [SUBMIT_CURRENT_LOAN_OFFER, SUBMIT_CURRENT_LOAN_OFFER_SUCCESS, SUBMIT_CURRENT_LOAN_OFFER_FAILURE],
    },
  };
}

/**
 * Submit Loan Selected Conditions
 */
export function selectLoanOfferConditions(principal, term, fee, monthlyInterestRate, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/select-offer-condition?principal=${principal}&term=${term}&fee=${fee}&monthlyInterestRate=${monthlyInterestRate}`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [SELECT_LOAN_OFFER, SELECT_LOAN_OFFER_SUCCESS, SELECT_LOAN_OFFER_FAILURE],
    },
  };
}

export function submitMobileCompatibility(isCompatible, brand, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/submit-mobile-compatibility?isCompatible=${isCompatible}&brand=${brand}`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [SUBMIT_MOBILE_COMPATIBILITY, SUBMIT_MOBILE_COMPATIBILITY_SUCCESS, SUBMIT_MOBILE_COMPATIBILITY_FAILURE],
    },
  };
}

export function submitAppInstallationDenial() {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/app-installation-denial`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [
        SUBMIT_APP_INSTALLATION_DENIAL,
        SUBMIT_APP_INSTALLATION_DENIAL_SUCCESS,
        SUBMIT_APP_INSTALLATION_DENIAL_FAILURE,
      ],
    },
  };
}

export function getCounterOffer(device, step, option, loanId, payDay) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/counter-offer?step=${step}&option=${option}&payDay=${payDay}&loanId=${loanId}`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [
        FIND_COUNTER_OFFER,
        {
          type: FIND_COUNTER_OFFER_SUCCESS,
          payload: async (action, state, response) => {
            try {
              return await response.text();
            } catch (error) {
              throw error;
            }
          },
        },
        {
          type: FIND_COUNTER_OFFER_FAILURE,
          payload: async (action, state, response) => {
            try {
              return await response.text();
            } catch (error) {
              throw error;
            }
          },
        },
      ],
    },
  };
}

export function tagGoogleAnalyticsEvent(eventName) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/tag-analytics-event?eventName=${eventName}`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [TAG_ANALYTICS_EVENT, TAG_ANALYTICS_EVENT_SUCCESS, TAG_ANALYTICS_EVENT_FAILURE],
    },
  };
}

export function getInstitutions() {
  return {
    [RSAA]: {
      endpoint: "/api/loan/application/institutions",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      types: [GET_INSTITUTIONS_REQUEST, GET_INSTITUTIONS_SUCCESS, GET_INSTITUTIONS_FAILURE],
    },
  };
}

export function createConsent(bankCode) {
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/consent?bankCode=${bankCode}`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      types: [
        CREATE_CONSENT_REQUEST,
        {
          type: CREATE_CONSENT_SUCCESS,
          payload: async (action, state, res) => {
            const response = await res.json();
            return response;
          },
        },
        CREATE_CONSENT_FAILURE,
      ],
    },
  };
}
